<app-page-shell>
    <p-toast position="bottom-center" [life]="10000"></p-toast>

    <app-page-hero eyebrow="Accounting Setup" [title]="pageTitle" [subtitle]="pageSubtitle">
        <div actions>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" type="button"
                (onClick)="cancel()"></p-button>
            <p-button label="Save" icon="pi pi-check" type="button" [loading]="isLoading"
                [disabled]="chartOfAccountsForm.invalid" (onClick)="saveChartOfAccounts()"></p-button>
        </div>
    </app-page-hero>

    @if (isLoading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
    }

    @if (isProtectedCurrentAccount) {
        <app-page-form-section icon="pi pi-lock" title="Posting Dependency"
            subtitle="This account is used by current posting automation.">
            <div class="compatibility-warning">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Name and account type are locked here so Chart of Accounts updates do not break journal posting in AccountingJournalEntryManager.</span>
            </div>
        </app-page-form-section>
    }

    <form [formGroup]="chartOfAccountsForm" (ngSubmit)="saveChartOfAccounts()" class="coa-form">
        <app-page-form-section icon="pi pi-sitemap" title="Account Details"
            subtitle="Maintain account identity, classification, currency, and parent structure.">
            <div class="formgrid grid">
                @if (editMode) {
                    <div class="field col-12 md:col-6">
                        <p-inputGroup>
                            <p-inputGroupAddon><i class="pi pi-key"></i></p-inputGroupAddon>
                            <p-iftaLabel>
                                <input id="accountId" type="text" pInputText formControlName="accountId" readonly
                                    class="p-disabled" />
                                <label for="accountId">Account ID</label>
                            </p-iftaLabel>
                        </p-inputGroup>
                    </div>
                }

                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="accountCode" type="text" pInputText formControlName="accountCode" readonly
                                class="p-disabled" />
                            <label for="accountCode">Account Code</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                    @if (!editMode) {
                        <small>Final code is assigned when saved.</small>
                    }
                    @if (chartOfAccountsForm.get('accountCode')?.invalid &&
                    chartOfAccountsForm.get('accountCode')?.touched) {
                        <small class="p-error">Account Code is required.</small>
                    }
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="accountName" type="text" pInputText formControlName="accountName" />
                            <label for="accountName">Account Name</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                    @if (chartOfAccountsForm.get('accountName')?.invalid &&
                    chartOfAccountsForm.get('accountName')?.touched) {
                        <small class="p-error">Account Name is required.</small>
                    }
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-list"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <p-select id="accountType" [options]="accountTypes" formControlName="accountType"
                                optionValue="value" optionLabel="label" [filter]="true"
                                styleClass="w-full"></p-select>
                            <label for="accountType">Account Type</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                    @if (chartOfAccountsForm.get('accountType')?.invalid &&
                    chartOfAccountsForm.get('accountType')?.touched) {
                        <small class="p-error">Account Type is required.</small>
                    }
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-code"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="internalType" type="text" pInputText formControlName="internalType" readonly
                                class="p-disabled" />
                            <label for="internalType">Internal Type</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>

                <div class="field col-12 md:col-6">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                        <p-iftaLabel>
                            <input id="currencyCode" type="text" pInputText formControlName="currencyCode" />
                            <label for="currencyCode">Currency</label>
                        </p-iftaLabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-form-section>

        <app-page-form-section icon="pi pi-folder" title="Parent Account"
            subtitle="New account codes are generated under the selected parent.">
            <div class="parent-summary">
                <div>
                    <strong>{{ parentAccountCode }}</strong>
                    <span>{{ parentAccountName }}</span>
                </div>
                <div>
                    <strong>{{ parentAccountTypeName }}</strong>
                    <span>Parent type</span>
                </div>
            </div>
        </app-page-form-section>
    </form>
</app-page-shell>
